export default function didSaySomething(volumeStats){
    const { maxVolume, minVolume } = volumeStats
    return maxVolume - minVolume > 18
}